<template>
  <v-container
    id="templateAnswerSummary"
    class="pa-0"
  >
    <v-row>
      <v-col
        v-for="(answer,i) in answers"
        :key="i"
        cols="12"
        :md="(answer.questionScreenWidth || 2) * 3"
      >
        <div
          v-if="isEmptyRequired(answer)"
        >
          <span
            class="display-value-label font-weight-medium text--primary"
          >
            {{ answer.question }}
          </span>
          <br class="d-flex d-sm-none">
          <span
            class="font-weight-light"
          >
            <v-icon
              slot="append"
              color="red"
            >
              mdi-alert
            </v-icon>
          </span>
        </div>
        <div
          v-if="!isEmptyRequired(answer)"
        >
          <div v-if="isDate(answer)">
            <base-display-date
              v-model="answer.answer"
              :label="answer.question"
            />
          </div>
          <div v-else-if="isBoolean(answer)">
            <base-display-value
              v-model="answer.answer"
              :label="answer.question"
              data-type="boolean"
            />
          </div>
          <div v-else>
            <base-display-value
              v-model="answer.answer"
              :label="answer.question"
            />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'TemplateAnswerSummary',

    props: {
      answers: {
        type: Array,
        default: null,
      },
    },

    methods: {
      getType (answer) {
        return ((answer || {}).answerDataType || 'string')
      },

      isEmptyRequired (answer) {
        const empty = !(answer || {}).answer
        const required = ((answer || {}).answerRequired || false)
        return (empty && required)
      },

      isNumber (answer) {
        return this.getType(answer) === 'number'
      },

      isDate (answer) {
        return this.getType(answer) === 'date'
      },

      isBoolean (answer) {
        return this.getType(answer) === 'boolean'
      },
    },
  }
</script>
